import { resolveUserAvatarUrl } from "../api/apiConfig/apiConfig";

export const DEFAULT_AVATAR_SRC = "/images/security/usericon.png";

export function pickProfilePictureFromUser(userDetails = {}) {
  const candidates = [
    userDetails?.profilePicture,
    userDetails?.profilepicture,
    userDetails?.profile_picture,
    userDetails?.avatar,
  ];
  for (const candidate of candidates) {
    if (candidate != null && String(candidate).trim()) {
      return String(candidate).trim();
    }
  }
  return "";
}

export function pickAvatarPathFromResponse(result) {
  if (result == null) return "";

  if (typeof result === "string" && result.trim()) {
    return result.trim();
  }

  if (typeof result !== "object") return "";

  const candidates = [
    result.avatar,
    result.avatarUrl,
    result.avatar_url,
    result.profilePicture,
    result.profilepicture,
    result.profile_picture,
    result.image,
    result.imageUrl,
    result.path,
    result.url,
    result.file,
    result.filename,
    result.data,
    result.data?.avatar,
    result.data?.avatarUrl,
    result.data?.avatar_url,
    result.data?.profilePicture,
    result.data?.profilepicture,
    result.data?.profile_picture,
    result.data?.image,
    result.data?.imageUrl,
    result.data?.path,
    result.data?.url,
    result.data?.file,
    result.data?.filename,
    result.data?.data?.avatar,
    result.data?.data?.avatarUrl,
    result.data?.data?.profilePicture,
    result.data?.data?.profilepicture,
    result.data?.data?.profile_picture,
    result.data?.data?.path,
    result.data?.data?.url,
  ];

  for (const candidate of candidates) {
    if (candidate == null) continue;
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
    if (typeof candidate === "object" && candidate !== null) {
      const nested =
        candidate.avatar ??
        candidate.profilePicture ??
        candidate.profilepicture ??
        candidate.profile_picture ??
        candidate.path ??
        candidate.url;
      if (nested != null && String(nested).trim()) {
        return String(nested).trim();
      }
    }
  }

  return "";
}

export function isApiSuccess(result) {
  if (!result || typeof result !== "object") return false;
  if (result.success === true) return true;
  if (result.status === true || result.status === "success") return true;
  if (result.code === 200 || result.statusCode === 200) return true;
  return Boolean(pickAvatarPathFromResponse(result));
}

export function withAvatarCacheBust(url, cacheKey = 0) {
  const base = String(url ?? "").trim();
  if (!base || cacheKey <= 0) return base;
  if (/^data:|^blob:/i.test(base)) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}v=${cacheKey}`;
}

/** Build a display URL for avatar paths returned by profile/settings APIs. */
export function resolveAvatarImageUrl(raw, cacheKey = 0) {
  const value = raw != null ? String(raw).trim() : "";
  if (!value) return DEFAULT_AVATAR_SRC;

  if (/^https?:\/\//i.test(value) || /^data:|^blob:/i.test(value)) {
    return withAvatarCacheBust(value, cacheKey);
  }

  if (value.startsWith("/images/") || value.startsWith("images/")) {
    return value.startsWith("/") ? value : `/${value}`;
  }

  return withAvatarCacheBust(resolveUserAvatarUrl(value), cacheKey);
}
